import { configureStore } from "@reduxjs/toolkit";
import visibleReducer from "../features/sidebar/sidebar";
import myreportReducer from "../features/my-report";

export const store = configureStore({
  reducer: {
    visible: visibleReducer,
    myreport: myreportReducer,
  },
});
